<!--
 * @Description: 取消关联机构dialog
 * @Author: gaohc
 * @Date: 2022-09-06 16:43:52
-->
<template>
  <div>
    <el-dialog class="cancel-affiliate-ins-dialog" width="640px" title="请谨慎操作"
      :visible.sync="visible" :close-on-click-modal="false" @open="initData"
      :before-close="handleCancel" center>
      <div style="padding-left: 25px;">
        <div class="hsp-name-wrap">
          <span>
						选择与
						<span class="hsp-name">
							{{ hospitalData.name }}
						</span>取消关联的机构：
					</span>
        </div>
        <el-checkbox-group class="cancel-ins-list" v-model="selectInstList">
          <el-checkbox v-for="(item, index) in bindingInst" :key="index" :label="item.id">
						{{ item.name }}
					</el-checkbox>
        </el-checkbox-group>
        <div class="describe-text-wrap">
          <i class="el-icon-warning"></i>
          <div class="warn-msg">
            <span>取消关联后，用户也无法在 </span>
            <span class="warn-text">{{ hospitalData.name }} </span>
            <span>购买机构的 </span>
            <span class="warn-text">服务</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer cancel-affiliate-ins-footer">
        <el-button class="cancel-btn" @click="handleCancel">
					考虑一下
				</el-button>
        <el-button class="cancel-affiliate-btn" @click="handleCancelAffiliateIns">
					取消关联
				</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";

export default {
  name: "CancelAffiliatedInstitutions",
  props: ["visible", "hspId"],
  data() {
    return {
      selectInstList: [], //选择要取消的关联机构列表
      bindingInst: [],
      hospitalData: {},
    };
  },

  methods: {
		// 取消关联操作
    handleCancelAffiliateIns() {
      if (!this.selectInstList.length) {
        this.$message.warning("请选择要取消关联的机构");
        return;
      }
      let params = {
        hospitalId: this.hspId,
        institutionIdList: this.selectInstList,
      };
      let header = this.encryptionUtil.signatureBody(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_UNBINDING_INSTITUTION_LIST,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
        this.clearData();
        this.$emit("close-dialog", true);
      });
    },

		// 获取关联机构的数据
    getUnBindingInstDo() {
      let params = {id: this.hspId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_HOSPITAL_DO4UNBINDING_INST,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
        this.hospitalData = result.data.hospital;
        this.bindingInst = result.data.simpleInstitutionList;
      });
    },

		initData() {
      this.getUnBindingInstDo();
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    clearData() {
      this.selectInstList = [];
      this.hospitalData = {};
      this.bindingInst = [];
    }
  }
};
</script>

<style scoped>
.hsp-name-wrap {
  color: #333333;
  font-size: 14px;
}

.hsp-name-wrap .hsp-name {
  color: #d61e06;
}

.cancel-ins-list {
  width: -webkit-fit-content;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
}

.cancel-ins-list .el-checkbox {
  margin-bottom: 10px;
}

.describe-text-wrap {
  margin-top: 25px;
  display: flex;
  align-items: baseline;
}

.describe-text-wrap .el-icon-warning {
  font-size: 20px;
  color: #d61e06;
}

.describe-text-wrap .warn-msg {
  color: #666666;
  font-size: 13px;
  line-height: 18px;
  margin-left: 5px;
}

.warn-msg .warn-text {
  color: #d61e06;
}
</style>

<style>
.cancel-affiliate-ins-dialog .el-dialog .el-dialog__header .el-dialog__title {
  color: #000000;
  font-size: 18px;
  font-weight: 400;
}

.cancel-affiliate-ins-dialog .el-dialog .el-dialog__header::after {
  background-color: #ffffff;
}

.cancel-affiliate-ins-footer {
  text-align: right;
}

.cancel-affiliate-ins-footer .cancel-affiliate-btn {
  color: #ffffff;
  background-color: #d61e06;
}

.cancel-affiliate-ins-footer .cancel-btn {
  color: #333333;
}

.cancel-ins-list .el-checkbox .is-checked .el-checkbox__inner {
  background-color: #d61e06;
  border-color: #d61e06;
}

.cancel-ins-list .el-checkbox .is-checked .el-checkbox__label,
.cancel-ins-list .el-checkbox .el-checkbox__label {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/components/hospitalList/CancelAffiatedInstututions.vue